function BouquetPhotoService ( $q, $http, $window, CityConfigService, AdditionalGoodsService )
{
    "ngInject";

    var options = {
            dropzoneConfig: {
                options: {
                    url: CityConfigService.options.city.base_url + '/api/handler.php',
                    addRemoveLinks: false,
                    method: "POST",
                    previewsContainer: '.dropzone-previews',

                    thumbnailWidth: 90,
                    thumbnailHeight: 90,

                    resizeWidth: 800,
                    resizeHeight: 800,
                    resizeMethod: 'contain',
                    resizeQuality: 80,

                    maxFiles: 4,
                    acceptedFiles: '.jpg, .jpeg, .png',

                    dictMaxFilesExceeded: 'Достигнут лимит на кол-во файлов',

                    previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n <a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove=\"\"><i class='glyphicon glyphicon-remove'></i></a>\n </div>",
                    params: {
                        request: 'loadImg'
                    }
                },
                eventHandlers: {
                    'success': function (file, response) {
                        succesEvent(file, response);
                    },
                    'removedfile': function (file) {
                        removedFileEvent(file);
                    }
                }
            },
            orderData: {
                selectedDelivery: {
                    selfdelivery_point: undefined
                },
                delivery_customer_name: '',
                delivery_client_name: '',
                is_anonymous: false,
                customer_phone_number: '',
                phone_number: '',
                delivery_region: undefined,
                delivery_address: '',
                date: undefined,
                time: undefined,
                images: [],
                noNeedText: '',
                cardText: '',
                order_comment: ''
            },
            loading: {
                forming: false,
                deliveryRegions: false,
                timePicker: false
            },

            termsOfUse: {
                isCheckTerms: true
            }
    };

    var clearOrderData = function ()
    {
        options.orderData =  {
            selectedDelivery: {
                selfdelivery_point: undefined
            },
            delivery_customer_name: '',
                delivery_client_name: '',
                is_anonymous: false,
                customer_phone_number: '',
                phone_number: '',
                delivery_region: undefined,
                delivery_address: '',
                date: undefined,
                time: undefined,
                images: [],
                noNeedText: '',
                cardText: '',
                order_comment: ''
        };
    }

    var succesEvent = function ( file, response )
    {
        file.path = response.data.path;
        options.orderData.images.push( response.data.path );
    }

    var removedFileEvent = function ( file )
    {
        $http({
            url: CityConfigService.options.city.base_url + "/api/handler.php",
            method: "POST",
            data: {
                request: 'deleteImg',
                data: file.path,
            }
        }).then(
            function ( response )
            {
                angular.forEach( options.orderData.images, function( item, key )
                {
                    if ( item == file.path )
                    {
                        delete item;
                    }
                });
            }
        ).catch( angular.noop );
    }


    var getDeliveryTypes = function ()
    {
        return $http({
            url: CityConfigService.options.city.base_url + "/api/handler.php",
            method: "GET",
            params: {
                request: 'getDeliveryTypes'
            }
        });
    };

    var getDeliveryRegions = function ()
    {
        return $http({
            url: CityConfigService.options.city.base_url + "/api/handler.php",
            method: "GET",
            params: {
                request: 'getDeliveryRegions'
            }
        });
    };

    /**
     * Метод запрашивающий время работы точки самовывоза
     */
    var getWorkingHours = function () {
        var selfDeliveryPointId = ( typeof( options.orderData.selectedDelivery.selfdelivery_point ) == "undefined" ) ? "" : options.orderData.selectedDelivery.selfdelivery_point.id;

        options.loading.timePicker = true;
        return $http({
            url: CityConfigService.options.city.base_url + "/api/handler.php",
            method: "GET",
            params: {
                request: 'getWorkhours',
                selfdeliveryPoint: selfDeliveryPointId
            },
            cache: false
        });
    };

    var doPurchase = function ()
    {
        var items = [];
        var sendingData = Object.assign( {}, options.orderData );

        var date = new Date( sendingData.date );


        sendingData.date_formatted = date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();

        sendingData.delivery_id = sendingData.selectedDelivery.id;
        if ( sendingData.selectedDelivery.selfdelivery )
        {
            sendingData.selfdelivery_point = sendingData.selectedDelivery.selfdelivery_point;
        }

        if ( sendingData.noNeedText )
        {
            sendingData.cardText = "";
        }

        if( typeof( sendingData.delivery_region ) !== 'undefined' ) {
            //sendingData.delivery_region = sendingData.delivery_region.id;
            sendingData.delivery_region = sendingData.delivery_region;
        }

        return $http({
            url: CityConfigService.options.city.base_url + "/api/handler.php",
            method: "POST",
            data: {
                request: 'orderOnPhoto',
                data: sendingData,
                items: items
            }
        });
    }

    return {
        options:  options,
        clearOrderData: function ()
        {
            return clearOrderData();
        },
        getDeliveryTypes: function ()
        {
            return getDeliveryTypes();
        },
        getDeliveryRegions: function ()
        {
            return getDeliveryRegions();
        },
        getWorkingHours: function ()
        {
            return getWorkingHours();
        },
        doPurchase: function ()
        {
            return doPurchase();
        }
    };
}

module.exports = BouquetPhotoService;